module.exports = __webpack_public_path__ + "static/media/Louise_Fresco_mobile.aa3308d8.jpg";